<template>
    <fragment>
        <div class="col-3" v-for="(email,index) in value">
                  <email-address v-model="value[index]" @update-default="updateDefault" @add-email="add" @remove-email="remove" :index="index" :readOnly="readonly" :first="index==0" :last="index==value.length-1"></email-address>
        </div>
        </fragment>
</template>
<script>
    import axios from 'axios';
  export default {
        name: 'emailaddresslist',
       
        props: {
            readonly: {
                type: Boolean,
                required: false,
                default:() => false
            },
            value: {
                type: Array,
                required: false
            }
        },
        data() {
            return {
                entityType: 'emailaddress',
                addTitle :'Aggiungi nuovo indirizzo email'
            }

        },
        components: {
           
        },
        methods: {
            updateDefault(email) {
                for (var i = 0; i < this.value.length; i++) {
                    if (this.value[i].emailId != email.emailId) {
                        this.value[i].default = false;
                        }
                }
                
            },
            add() {
                var me = this;
                axios.get('utility/new/' + me.entityType).then(response => {
                    me.value.push(response.data);

                });
            }
            , remove(email) {
                console.log("remove","e")
                var me = this;
                var delIndex = -1;
               for (var i = 0; i < this.value.length; i++) {
                    if (this.value[i].emailId != email.emailId) {
                        delIndex = i;
                        break;
                        }
                }
                if (delIndex >= 0) {
                    this.value.splice(delIndex, 1);
                }
            }
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
